export default __webpack_public_path__ + "static/media/app-screen-mockup.ccf5e226.png";